import { ListTableColumn, createListTableColumns, renderDateTime } from "sprint-common-web";

import { getIntegratorDetailsDashboardHref } from "../../AdminRoutes";
import { DeleteIntegratorButton } from "./buttons/delete/DeleteIntegratorButton";
import { IntegratorItem } from "./IntegratorItem";

export const createIntegratorListingColumns = (): ListTableColumn<IntegratorItem>[] => {
    return createListTableColumns<IntegratorItem>([
        {
            type: "link",
            key: "name",
            name: "Name",
            minWidth: 200,
            maxWidth: 380,
            isSortable: true,
            getHref: (item) => getIntegratorDetailsDashboardHref(item.id)
        },
        {
            type: "basic",
            key: "updatedDate",
            name: "Updated",
            minWidth: 100,
            maxWidth: 280,
            isSortable: true,
            onRender: renderDateTime
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 197,
            maxWidth: 197,
            isResizable: false,
            buttons: [
                {
                    id: "deleteIntegrator",
                    render: DeleteIntegratorButton
                }
            ]
        }
    ]);
};
